import React from 'react';
import { FileText, Clock, FlameIcon } from 'lucide-react';

const DesignOptionsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  projectStages,
  urgencyTypes
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <FileText className="w-5 h-5 mr-2 text-indigo-500" />
        Параметры проектирования
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Этап проектирования */}
        <div>
          <label htmlFor="projectStage" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Этап проектирования
          </label>
          <select
            id="projectStage"
            name="projectStage"
            value={formData.projectStage}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.projectStage ? 'input-error' : ''}`}
          >
            <option value="">Выберите этап</option>
            {projectStages.map((stage) => (
              <option key={stage.id} value={stage.id}>
                {stage.name} ({stage.percentage}%)
              </option>
            ))}
          </select>
          {errors.projectStage && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.projectStage}
            </p>
          )}
        </div>

        {/* Срочность проекта */}
        <div>
          <label htmlFor="urgency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Срочность проекта
          </label>
          <select
            id="urgency"
            name="urgency"
            value={formData.urgency}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.urgency ? 'input-error' : ''}`}
          >
            <option value="">Выберите срочность</option>
            {urgencyTypes.map((urgency) => (
              <option key={urgency.id} value={urgency.id}>
                {urgency.name} {urgency.factor > 1 ? `(коэф. ${urgency.factor})` : ''}
              </option>
            ))}
          </select>
          {errors.urgency && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.urgency}
            </p>
          )}
        </div>

        {/* Количество итераций правок */}
        <div>
          <label htmlFor="revisionRounds" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество итераций правок
          </label>
          <input
            type="text"
            id="revisionRounds"
            name="revisionRounds"
            value={formData.revisionRounds}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.revisionRounds ? 'input-error' : ''}`}
            placeholder="Сколько раз можно вносить правки"
          />
          {errors.revisionRounds && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.revisionRounds}
            </p>
          )}
        </div>

        {/* Тип клиента */}
        <div>
          <label htmlFor="clientType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип клиента
          </label>
          <select
            id="clientType"
            name="clientType"
            value={formData.clientType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="individual">Частное лицо</option>
            <option value="business">Юридическое лицо</option>
            <option value="government">Государственный заказчик</option>
          </select>
        </div>

        {/* Валюта расчета */}
        <div className="col-span-full md:col-span-1">
          <label htmlFor="currencyType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Валюта расчета
          </label>
          <select
            id="currencyType"
            name="currencyType"
            value={formData.currencyType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="RUB">Российский рубль (₽)</option>
            <option value="USD">Доллар США ($)</option>
            <option value="EUR">Евро (€)</option>
          </select>
        </div>

        {/* Дополнительные требования */}
        <div className="col-span-full">
          <label htmlFor="additionalRequirements" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Дополнительные требования
          </label>
          <textarea
            id="additionalRequirements"
            name="additionalRequirements"
            value={formData.additionalRequirements}
            onChange={handleInputChange}
            rows="3"
            className="form-textarea w-full"
            placeholder="Опишите особые требования к проекту (опционально)"
          />
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-4 bg-amber-50 dark:bg-amber-900/20 p-3 rounded-lg border border-amber-100 dark:border-amber-800 text-sm">
        <div className="flex items-start">
          <Clock className="w-5 h-5 text-amber-600 dark:text-amber-400 mr-3 mt-1 flex-shrink-0" />
          <div>
            <h4 className="font-medium text-amber-700 dark:text-amber-300 mb-1">Сроки и этапы</h4>
            <p className="text-xs text-amber-600 dark:text-amber-400">
              Выбор этапа проектирования определяет объем выполняемых работ. Срочность выполнения проекта влияет на стоимость: 
              чем выше срочность, тем больше будет стоимость. Стандартные сроки позволяют сэкономить бюджет.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignOptionsSection;